import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { VOffline } from 'v-offline';
import VueContext from 'vue-context'
import i18n from '@/plugins/i18n';
import FlagIcon from 'vue-country-flag'
import moment from 'moment';
import { EventBus } from './event-bus';
import VueSessionStorage from 'vue-session';
import { WebSocketClient } from './models/WebSocketClient';
//import { SignalRClient } from './models/SignalRClient';
import { WebSocketInfo } from './models/WebSocketInfo';
import VueMoment from 'vue-moment';
import CountryFlag from 'vue-country-flag'
import VueApexCharts from 'vue-apexcharts';
import { hiddenFeature, isValid } from './utils/utilitiesmodule';
import { selectValues } from './utils/selectvalues';
import "./utils/prototypes/simplePrototypes.js";
import "./utils//prototypes/clientTreeNodePrototypes.js";
import { installVuePrototypes } from './utils/prototypes/sessionPrototypes.js';
import { PC_MESSAGES, USER_MESSAGES } from './utils/messages.js';
import { installVueDirectives } from './utils/vuedirectives.js';
import JSZip from 'jszip';
import { _ } from 'core-js';
import { ClientMessage, DateHelper } from './utils/objects.js';
import { OneSignalSetup } from './utils/OneSignalSetup.js';


Vue.use(VueSessionStorage)

Vue.use(require('vue-cookies'))
Vue.use(VueMoment, { moment })
Vue.component('apexchart', VueApexCharts);
Vue.component('country-flag', CountryFlag)
Vue.config.productionTip = false
let appKey = 0;
//Vue.$cookies.config('7d', '', '', true)



if (process.env.VUE_APP_IS_PROD === 'true' || process.env.NODE_ENV === 'production') {
    console.info("Running in production mode");
    Vue.config.devtools = false;        // Disabilita il Vue Devtools
    Vue.config.debug = false;           // Disabilita messaggi di debug
    Vue.config.productionTip = false;   // Disabilita il messaggio nella console
}

// Recupera l'ultima rotta salvata dalla session storage
const lastRoute = sessionStorage.getItem('lastRoute');
const isRootNavigation = window.location.pathname === '/';
if (isRootNavigation && lastRoute && lastRoute !== '/' && lastRoute !== '/?') {
    router.push(lastRoute); // Reindirizza alla rotta salvata
}

const now = Date.now();
const lastVisit = localStorage.getItem('lastVisit');

if (!lastVisit || now - lastVisit > 24 * 60 * 60 * 1000) {
    // Forza il reload completo invalidando la cache
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ action: 'invalidateCache' });
    }
}

localStorage.setItem('lastVisit', now);


window.app = new Vue({
    router,
    store,
    i18n,
    VOffline,
    FlagIcon,
    EventBus,
    Metro,
    data() {
        return {
            authObj: null,

            //signalr: null,
            websocket: null,
            checkConnectionTimer: null,
            connectionsStates: {},//[],//
            //Timer che controlla la connessione remote dei pc memorizzati in remote_map_idPC_idRemote
            remote_checkConnectionTimer: null,
            remote_connectionsStates: {},
            //remote_checkConnectionTimer monitora la connessione remote dei pc memorizzati in questa mappa
            remote_map_idPC_idRemote: {},

            logs: [],
            originalLog: null,
            //originalError: null,
            originalWarn: null,
            originalInfo: null,
            atLeastOnePCConnectedToSocket: false, //indica se è connesso almeno un pc
            socketConnected: false,

            //Mappe utili
            selectValues: null,

            serviceAccounts: [],
            repositories: [],
            forceRefreshID: 0,
            backupIDForView: null,
            noIperiusOneLicense: true,
            noIperiusOneLicensePolicies: true,
            ticketingEnabled: false,

            roomPCInfo: {
                id: null,
                subscribed: false,
                receivingRealtimeData: false
            },

            notifications: [],

            teamMap: null,
            customerMap: null,
            userMap: null,
            pcMap: null,
			userLoggedIsLeadOfSomeTeam: false,
			usefulMapsPromise: null,
			ecommerceUpgradeUrl: process.env.VUE_APP_ECOMM_SITE_URL,
			ecommerceUpgradeUrlPromise: null

            //pc: null
        }
    },
    computed: {
        hiddenFeature() {
            return hiddenFeature();
        },
        siteURL() {
            return window.location.origin;
        },
        serverURL() {
            return process.env.VUE_APP_BASE_URL.replace("/rest/api", "").replace("http://", "").replace("https://", "");
        }
    },
    watch: {
        '$route': {
            handler: function (to) {
                this.authObj = this.getAuth();
                if (!this.authObj || this.authObj.licenceExpired) {
                    return;
                }
                var prev_idPC, curr_idPC;
                var callCheckSocket = true;
                setTimeout(async () => {
                    prev_idPC = this.roomPCInfo.id;
                    curr_idPC = to.params.idPC;
                    callCheckSocket = true;
                    try {
                        //Si passa da una NON roomPC a una NON roomPC
                        if (prev_idPC == null && curr_idPC == undefined) {
                            return;
                        }

                        //Si entra in una roomPC (es: da dashboard a computer)
                        if (prev_idPC == null && curr_idPC != undefined) {
                            this.startToListenPC(curr_idPC);
                            callCheckSocket = false;
                            this.roomPCInfo.id = curr_idPC;
                            return;
                        }

                        //Si passa da una roomPC all'altra
                        if (curr_idPC != undefined && prev_idPC != curr_idPC) {
                            callCheckSocket = false;
                            await this.stopToListenPC(prev_idPC);
                            this.startToListenPC(curr_idPC);
                            callCheckSocket = false;
                            this.roomPCInfo.id = curr_idPC;
                            return;
                        }

                        //Si entra nella stessa roomPC
                        if (curr_idPC != undefined && prev_idPC == curr_idPC) {
                            this.$root.$emit("roomPCConnectionStatus", this.connectionsStates[curr_idPC]);
                            return;

                        }

                        //Si esce da una roomPC (es. da computer a dashboard)
                        if (prev_idPC != null && curr_idPC == undefined) {
                            await this.stopToListenPC(prev_idPC);
                            this.roomPCInfo.id = null;
                        }
                    } finally {
                        if (to.path == '/' || !callCheckSocket || to.meta?.skipSocket) {
                            return;
                        }

                        let self = this;
                        this.$off("socketEventConnected");
                        this.$off("socketEventDisconnected");
                        this.$root.$on("socketEventConnected", () => {
                            self.socketConnected = true;
                            self.checkConnectionTimerLight();
                            self.forceRefreshID += 1;
                            //self.startToListenPC(self.idPC);
                        });
                        this.$root.$on("socketEventDisconnected", () => {
                            self.socketConnected = false;
                            if (self.checkConnectionTimer != null) {
                                clearInterval(self.checkConnectionTimer);
                                self.checkConnectionTimer = null;
                            }
                            //self.setDefaultData();
                        });


                        this.checkSocket();
                    }
                }, 1000);

            },
            deep: true,
            immediate: true
        },
    },
    created: function () {

        var self = this;
        this.selectValues = selectValues;
        installVuePrototypes(Vue);
        installVueDirectives(Vue);

        this.checkAuth();
        OneSignalSetup.init();

        this.$api.vueEnvironment = this;
        this.$api.createToastFunction = this.toast;
        this.$api.translateFunction = this.translateFunction;
        this.$api.emitFunction = this.emitFunction;

        //MODIFICA CONSOLE-----------------------------------------------------------------------------------
        this.originalLog = console.log;
        this.originalError = console.error;
        this.originalWarn = console.warn;
        this.originalInfo = console.info;

        console.buildMessage = function (args) {
            const logType = String(args[0] || '').toUpperCase();
            args.splice(0, 1);

            const time = (new Date()).toISOString();

            const stackRaw = (new Error()).stack || '';
            const lines = String(stackRaw).split(/\r?\n/);

            // escludi la prima riga ("Error") e questa funzione stessa
            const frames = lines.slice(1).filter(l =>
                !l.contains("buildMessage") &&
                !l.contains("console.log") &&
                !l.contains("console.error") &&
                !l.contains("console.writeError") &&
                !l.contains("console.warn") &&
                !l.contains("console.info") &&
                !l.contains("Vue.toast") &&
                !l.contains("Vue.emitFunction")
            );

            // parser per Chrome/Edge/Node: "at fn (file:line:col)" o "at file:line:col"
            const reChrome1 = /^\s*at\s+(.+?)\s+\((.+):(\d+):(\d+)\)\s*$/;
            const reChrome2 = /^\s*at\s+(.+):(\d+):(\d+)\s*$/;

            // parser per Firefox/Safari: "fn@file:line:col" o "file:line:col"
            const reFF1 = /^(.+?)@(.+):(\d+):(\d+)$/;
            const reFF2 = /^(.+):(\d+):(\d+)$/;

            function parseFrame(line) {
                let m;
                if ((m = line.match(reChrome1))) return { fn: m[1], file: m[2], line: +m[3], col: +m[4] };
                if ((m = line.match(reChrome2))) return { fn: null, file: m[1], line: +m[2], col: +m[3] };
                if ((m = line.match(reFF1))) return { fn: m[1], file: m[2], line: +m[3], col: +m[4] };
                if ((m = line.match(reFF2))) return { fn: null, file: m[1], line: +m[2], col: +m[3] };
                return null;
            }

            // prendi il primo frame utile
            let frame = null;
            for (const l of frames) {
                const f = parseFrame(l.trim());
                if (f) { frame = f; break; }
            }

            // costruisci "from": NomeFunzione o file:line
            let from;
            if (frame) {
                const fileShort = frame.file ? frame.file.split(/[\\/]/).pop() : '';
                from = frame.fn
                    ? frame.fn
                    : (fileShort ? `${fileShort}:${frame.line}` : 'unknown');
            } else {
                from = 'unknown';
            }

            // serializzazione argomenti
            function varToString(a) {
                try {
                    if (typeof a === 'string') return a;
                    if (Array.isArray(a)) return a.map(varToString);
                    if (a && typeof a === 'object') {
                        const s = JSON.stringify(a, null, 2);
                        return s === '{}' ? String(a) : `\n${s}\n`;
                    }
                    return String(a);
                } catch (e) {
                    return '[Unserializable object]';
                }
            }

            const argsToString = args.map(varToString).join(' ');
            const msg = `[${time}]    [${logType}]    ${from}    ${argsToString}`;
            return msg;
        };



        console.log = function (...args) {
            if (args.length == 0)
                return;
            var msg = console.buildMessage(["LOG"].concat(args));
            if (msg.contains("HTMLUListElement"))
                return;
            /*if (window.location.origin.contains("localhost")) {
                self.originalLog.apply(console, [msg]);
            }*/
            console.debug(msg);
        };

        //Questo metodo verrà chiamato automaticamente dagli errori non gestiti, provenienti da Javascript stesso
        /*console.error=function(...args) {
            if (args.length==0||[null, {}, ""].includes(args[0])) {
                return;
            }
            if (args.length==1&&typeof args[0]=="TypeError") {
                args=[args[0].message, args[0].stack];
            }
            const msg=console.buildMessage(["UI ERROR"].concat(args));
            self.originalError.apply(console, [msg]);
            if (!console.logsList) {
                console.logsList=[];
            }
            console.logsList.push(msg);
        };*/

        //Questo è il metodo per scrivere gli errori gestiti
        console.writeError = function (...args) {
            if (args.length == 0 || [null, {}, ""].includes(args[0]))
                return;

            if (args.length == 1 && typeof args[0] == "TypeError") {
                args = [args[0].message, args[0].stack];
            }

            const msg = console.buildMessage(["ERROR"].concat(args));
            //self.originalError.apply(console, [msg]);
            /*if (window.location.origin.contains("localhost")) {
                self.originalLog.apply(console, [msg]);
            }*/
            console.debug(msg);

            if (!console.logsList) {
                console.logsList = [];
            }
            console.logsList.push(msg);
        };

        console.warn = function (...args) {
            if (args.length == 0)
                return;
            const msg = console.buildMessage(["WARNING"].concat(args));
            /*if (window.location.origin.contains("localhost")) {
                self.originalWarn.apply(console, [msg]);
            }*/
            console.debug(msg);

            if (!console.logsList) {
                console.logsList = [];
            }
            console.logsList.push(msg);
        };

        /*console.info=function(...args) {
            if (args.length==0)
                return;

            console.debug(args);

            /*if (window.location.origin.contains("localhost")) {
                self.originalInfo.apply(console, [console.buildMessage(["INFO"].concat(args))]);
            }*/
        /* };*/



        //MODIFICA WINDOW-----------------------------------------------------------------------------------------
        //require("dotenv").config();
        // salva i riferimenti
        this._onBeforeUnload = (event) => {
            // ATTENZIONE: beforeunload non supporta await.
            // Fai una chiusura rapida/sincrona, o usa sendBeacon/websocket close senza await.
            try { this.closeSocket && this.closeSocket(); } catch (e) { }
        };

        this._onStorage = (event) => {
            if (event.key === "sessionData" && event.newValue) {
                try {
                    console.info("Nuovi dati di sessione ricevuti:", JSON.parse(event.newValue));
                } catch (e) {
                    console.warn("sessionData non JSON:", event.newValue);
                }
            }
        };

        this._onKeydown = (e) => this.handleShortcut && this.handleShortcut(e);

        this._onContextMenu = (e) => {
            e.preventDefault();
        };

        // registra
        window.addEventListener("beforeunload", this._onBeforeUnload);
        window.addEventListener("storage", this._onStorage);
        window.addEventListener("keydown", this._onKeydown);
        document.addEventListener("contextmenu", this._onContextMenu);

        OneSignalSetup.registerServiceWorker();
    },


    methods: {
        login(rememberme) {
            if (!this.checkAuth()) {
                return;
            }

            if (!this.$session.exists()) {
                this.$session.start();
            }

            if (rememberme) {
                localStorage.setItem("AUTH", JSON.stringify(this.authObj));
            } else {
                this.$session.setAuth(this.authObj);
                localStorage.setItem("AUTH", JSON.stringify(this.authObj));
            }
            this.$store.commit('SET_LAYOUT', 'nav-layout');

            if (this.authObj.licenceExpired) {
                if (this.$route.path != '/expiredlicence') {
                    this.$router.replace('/expiredlicence');
                }
                return;
            }

            this.$session.setLicense({ id: this.authObj.id_master_account, assignee: this.authObj.nome_licenza });

            OneSignalSetup.subscribeUser(this.authObj.id_user, this.$i18n.locale);

            if (this.$route.path != '/dashboard') {
                this.$router.replace('/dashboard');
            }
        },

        async getApiDataAndSetSession() {

            if (!this.checkAuth()) {
                return;
            }

            let self = this;

            self.$session.setLicense({ id: this.authObj.id_master_account, assignee: this.authObj.nome_licenza });

            self.$session.setLicenses(await self.$api.getLicenseExtendedInfo());

            self.noIperiusOneLicense = this.$session.getLicenses()?.backup?.length === 0;

            self.noIperiusOneLicensePolicies = this.$session.getLicenses()?.monitoring?.length === 0;

            // Ticketing/Fatturazione: visibili se siamo in localhost oppure se la licenza "ticketing" è un array non vuoto.
            const ticketingLicenses = this.$session.getLicenses()?.ticketing;
            self.ticketingEnabled = (Array.isArray(ticketingLicenses) && ticketingLicenses.length > 0);

            //PC
            self.$api.getPCListUltraLite().then(pcs => {
                if (pcs == null) {
                    return;
                }
                Object.assign(this.remote_connectionsStates, pcs.reduce((obj, pc) => ({ ...obj, [pc.id]: false }), {}));
                self.$session.setPCList(pcs);
                self.checkConnectionTimerLight();
            });

            self.$api.getGroups().then(res => {
                self.$session.setGroups(res);
            });


            //UTENTI
            self.$api.getUsers().then(res => {
                self.$session.setUsers(res);
            });

            self.$api.getRoles().then(res => {
                self.$store.commit('SET_ROLES', res);
                self.$session.setRoles(res);
            });


            //POLICY
            self.$api.getPolicies().then(res => {
                self.$session.setPolicies(res);
            });
            this.$api.getPolicyTypes().then(res => {
                self.$store.commit('SET_POLICY_TYPES', res);
                self.$session.setPolicyTypes(res);
            });

            self.$api.getServiceAccounts().then(serviceAccounts => {
                self.$session.setServiceAccounts(serviceAccounts);
            });

            self.$api.getRepositories().then(repositories => {
                self.$session.setRepositories(repositories);
            });

            self.$api.getTeams().then(teams => {
                self.$session.setTeams(teams);
            });

            //EVENTI


            //VARIE

        },

        handleShortcut(e) {
            if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'o') {
                e.preventDefault(); // evita che il browser faccia altro
                this.salvaLogInZip();
            }
        },

        exportLogs() {
            //ISO non va bene perchè contiene caratteri speciali
            const date_time = new Date().ddMMyyyyHHmmss();
            const fileName = 'IperiusONE_Logs_' + date_time;
            if (!console.logsList) {
                console.logsList = [];
            }
            const logText = console.logsList.join("\r\n");
            const zip = new JSZip();

            zip.file(fileName + ".log", logText);

            zip.generateAsync({ type: "blob" })
                .then(function (blob) {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = fileName + ".zip";
                    a.click();
                    URL.revokeObjectURL(url);
                });


            /*VERSIONE VERO
             
            const blob=new Blob([logText], { type: 'text/plain' });
            const url=URL.createObjectURL(blob);

            const a=document.createElement('a');
            a.href=url;
            a.download=+new Date().ddMMyyyyHHmmss()+'.txt';
            a.click();

            URL.revokeObjectURL(url);
             */



        },

        createhintGroups(groupsList, isString = false) {
            var hint = "";
            groupsList.forEach(group => {
                hint += "• " + (isString ? group.toUpperCase() : group.name.toUpperCase()) + "<br> ";
            });
            return hint.substring(0, hint.length - 2);
        },

        format(time) {

            // Hours, minutes and seconds
            var hrs = ~~(time / 3600);
            var mins = ~~((time % 3600) / 60);
            var secs = ~~time % 60;

            // Output like "1:01" or "4:03:59" or "123:03:59"
            var ret = "";
            if (hrs > 0) {
                ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
            }
            ret += "" + mins + ":" + (secs < 10 ? "0" : "");
            ret += "" + secs;

            return ret;
        },

        //Veronica - 08/08/2024
        openYesNoDialog(id, title, content, okBtn_text = this.$t("Yes"), cancelBtn_text = this.$t("No"), okBtn_class = "js-dialog-close secondary", cancelBtn_class = "js-dialog-close alert") {
            this.openDialogActions(id, title, content, okBtn_text, okBtn_class, true, cancelBtn_text, cancelBtn_class, false);
        },

        openInsertTextDialog(id, title, label, placeholder, initialValue, maxlength = 100) {
            var content = "<label>{0}</label><input type='text' id='newText' placeholder='{1}' value='{2}' class='input rounded border mt-2' maxlength='{3}' />"
                .format(label, placeholder, initialValue, maxlength);

            this.openDialogActions(id, title, content, this.$t("Save"), "mr-2 secondary", "", this.$t("Cancel"), "js-dialog-close");
        },

        openDialogActions(id, title, content, okBtn_text = this.$t("Yes"), okBtn_class = "mr-2 secondary", okBtn_result = true, cancelBtn_text = this.$t("No"), cancelBtn_class = "alert", cancelBtn_result = false) {

            let self = this;
            var okFunction, cancelFunction;

            //Se la dialog è stata aperta per permettere di inserire un testo, devo ritornare il testo inserito
            if (content.contains("id='newText'")) {
                okFunction = () => {
                    self.$root.$emit(id, $("#newText")[0].value);
                };
                cancelFunction = () => {
                    self.$root.$emit(id, "");
                }
            } else {
                okFunction = () => {
                    self.$root.$emit(id, okBtn_result);
                };
                cancelFunction = () => {
                    self.$root.$emit(id, cancelBtn_result);
                };
            }


            return Metro.dialog.create({
                title: title,
                content: content,
                clsDialog: "dialog light pos-center bg-light dialog-topmost " + id,
                clsContent: "bg-light",
                closeAction: true,
                removeOnClose: true,
                actions: [{
                    caption: this.$t(okBtn_text),
                    cls: okBtn_class,
                    onclick: () => {
                        okFunction();
                        if (document.getElementsByClassName(id).length != 0) {
                            Metro.dialog.close(document.getElementsByClassName(id)[0]);
                        }
                    }
                },
                {
                    caption: this.$t(cancelBtn_text),
                    cls: cancelBtn_class,
                    onclick: () => {
                        cancelFunction();
                        if (document.getElementsByClassName(id).length != 0) {
                            Metro.dialog.close(document.getElementsByClassName(id)[0]);
                        }
                    }
                }
                ],
                /* onClose: function(el) {
                    console.log(el);
                    this.$root.$emit(id, cancelBtn_result);
 
                } */
            });

        },

        openOnlyOkDialog(id, title, content, okBtn_text = this.$t("Ok"), okBtn_class = "js-dialog-close secondary") {
            this.openDialogOk(id, title, content, okBtn_text, okBtn_class, true);
        },

        openDialogOk(id, title, content, okBtn_text, okBtn_class, okBtn_result) {
            let self = this;

            const okFunction = () => self.$root.$emit(id, okBtn_result);

            return Metro.dialog.create({
                title: title,
                content: content,
                clsDialog: "dialog light pos-center dialog-topmost",
                clsContent: "bg-light",
                closeAction: true,
                actions: [
                    {
                        caption: this.$t(okBtn_text),
                        cls: okBtn_class,
                        onclick: okFunction
                    }
                ]
            });
        },


        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.replace('/')
        },

        //se non ci sta nel local storage lo prendo dalla session
        checkAuth() {
            if (!this.authObj) {

                this.authObj = this.getAuth();
                if (!this.authObj) {
                    return false;
                }

                if (!this.authObj.licenceExpired) {
                    this.$session.setLicense({ id: this.authObj.id_master_account, assignee: this.authObj.nome_licenza });
                }
            }

            if (this.authObj.licenceExpired == undefined) {
                const expirationDate = DateHelper.parseUtc(this.authObj.dataora_scadenza);
                this.authObj.licenceExpired = expirationDate != null && expirationDate.isBefore();

            }
            if (this.authObj.licenceExpired) {
                if (this.$route.path != '/expiredlicence') {
                    this.$store.commit('SET_LAYOUT', 'nav-layout');
                    this.$router.replace('/expiredlicence');
                }
                return true;
            }

            return true;
        },
        getAuth() {
            if (this.authObj) {
                return this.authObj;
            }
            try {
                return JSON.parse(localStorage.getItem("AUTH"));
            } catch {
                return this.$session.getAuth();
            }
        },

        // Funzione per generare colori varianti dello stesso colore base
        generateBlueShades(baseColor, numberOfShades) {
            const colors = [];
            for (let i = 1; i <= numberOfShades; i++) {
                const lightness = Math.round(i * (100 / numberOfShades)); // Calcola la luminosità
                const color = 'hsl(' + baseColor + ',68%,' + lightness + '%)'; // Imposta la tonalità del blu a 210 (blu) e varia solo la luminosità
                colors.push(color);
            }
            return colors;
        },

        /*****************************MESSAGGI*****************************************************************************************************/
        //Il messaggio deve essere già tradotto
        //Secondo la documentazione ufficiale di Metro UI (https://docs.metroui.org.ua/toast.html), clsToast deve essere uno dei seguenti valori : 
        // - primary (blu), 
        // - secondary (grigio)
        // - success (verde)
        // - alert (rosso)
        // - warning (arancione)
        // - yellow (giallo)
        // - info (celeste)
        // - light (grigio chiarissimo, quasi trasparente)
        /*
        <div class="notify alert" id="notify-1763403092056146" style="width: 400px; margin-top: 4px; opacity: 0.057;"><div class="notify-message">Sei offline.</div></div>
        */
        async toast(message, level) {
            const notificationMessage=String(message||'');
            const notificationLevel=level!=null? String(level).toLowerCase():"info";
            const levelToUpperCase=notificationLevel.toUpperCase();
            const logMessage="[{0}] {1}".format(levelToUpperCase, notificationMessage);

            switch (levelToUpperCase) {
                default:
                    console.log(logMessage);
                    break;
                case "SUCCESS":
                case "OK":
                case "INFO":
                    console.info(logMessage);
                    break;
                case "ALERT":
                case "ERROR":
                    console.log(logMessage);
                    break;
                case "WARNING":
                    console.warn(logMessage);
                    break;
            }
            const notification={
                id: Date.now()+Math.random(),
                message: notificationMessage,
                level: notificationLevel,
                createdAt: new Date()
            };
            this.notifications.unshift(notification);
            this.notifications.splice(5);
            this.$emit('NEWNOTIFICATION', notification);
        },

        calculateToastTimeout(message) {
            if (!message) return 3000; // default

            const words = message.trim().split(/\s+/).length;

            const base = 2000;      // 2 secondi di base
            const perWord = 300;    // 0,3s per parola

            let timeout = base + words * perWord;

            // Limiti minimo/massimo
            const min = 3000;       // almeno 3 secondi
            const max = 15000;      // massimo 15 secondi

            timeout = Math.max(min, Math.min(max, timeout));

            return timeout;
        },

        /****************************INIZIO CHIAMATE SOCKET*********************************************************************************************************/
        /**
         * Implementazione
         * 1- In src/models/WebSocketInfo:
         *     1.2 - Aggiungere nel metodo buildInfo il case adeguato, in cui si implementa
         *         1.2.1 - Il caso in cui si chiama il metodo prima di effettuare la richiesta (forRequest=true + eventuali argomenti in arg1, arg2...)
         *         1.2.2 - Il caso in cui la risposta è andata a buon fine (forRequest=false + okResponse=true + arg1 eventuale dato ritornato dalla risposta).
         *                 Se la risposta è stata ricevuta con un oggetto in cui msg_type==data (vedere i msg_type in src/models/WebSocketClient.js -> onMessgeCallback), arg1 è il dato ricevuto.
         *                 Altrimenti okResponse è l'esito dela chiamata, quindi aggiungere in public/js/messages.js l'eventuale messaggio relativo alla buona riuscita della chiamata
         *         1.2.3 - Il caso in cui la risposta non è andata a buon fine (forRequest=false + okResponse=false). 
         *                 In questo caso verrà generato un toast per comunicare l'errore, quindi aggiungere in public/js/messages.js il relativo messaggio
         * Utilizzo: chiamare this.$root.socket("medoto_socket", argomento_1, argomento_2 ecc).
         */
        async socket(message, arg1, arg2, arg3) {
            let self = this;
            if (this.websocket == null) {
                console.debug("è stato tentato di fare la chiamata socket \"" + message + "\" ma websocket è null");
                return;
            }

            //Se non è impostato l'id pc, provo ad impostarlo con il room pc se esiste
            if (this.websocket.idPC == null) {
                this.websocket.idPC = this.$session.getRoomPC() == null ?
                    null :
                    this.$session.getRoomPC().id;
            }

            if (message.toUpperCase() == "SETPC") {
                this.websocket.idPC = arg1 == null ?
                    null :
                    typeof (arg1) == "string" ?
                        arg1 :
                        arg1.id; // messageargs è l'id o il pc da impostare
                return;
            }

            //Step 1 : Controllo la connessione. Se fallisce
            if (!this.socketConnected) {
                //Step 1.1 : si visualizza un toast per comunicare all'utente che non è connesso
                //this.connectionMessage(false);

                var currentPC = isValid(this.$session.getRoomPC()) ?
                    this.$session.getRoomPC()
                    //step 4.2 : se non sono in un pc ma è stato impostato un computer, comunico che tale computer non è connesso
                    :
                    this.$session.getPCWithID(this.websocket.idPC)

                // Step 1.2 : si ritorna il risultato di default

                var msgObj = {
                    text: isValid(currentPC) ? currentPC.notConnectedDefaultMessage : USER_MESSAGES.NOT_CONNECTED,
                    msgType: "ERROR",
                    msgArgs: null
                };

                var errorResult = WebSocketInfo.buildInfo(message.toUpperCase(), false, false, msgObj);
                return errorResult.result;
            }


            //Step 2 : Si tenta la chiamata.
            var info = await self.websocket.call(message, arg1, arg2, arg3);
            // Step 3 : Se l'oggetto ritornato non ha un messaggio che deve essere visualizzato, ritorno subito il risultato
            if (!isValid(info.message)) {
                return info.result;
            }

            //Step 4 : Se l'oggetto ritornato ha un messaggio che comunica che il computer non è connesso
            //devo impostare come argomento del messaggio iò nome del pc
            if (info.message.text == PC_MESSAGES.NOT_CONNECTED) {
                //Step 4.1 : se sono in un pc, comunico che roompc non è connesso
                var currentPC = isValid(this.$session.getRoomPC()) ?
                    this.$session.getRoomPC() :
                    //step 4.2 : se non sono in un pc ma è stato impostato un computer, comunico che tale computer non è connesso
                    isValid(this.websocket.idPC) ?
                        this.$session.getPCWithID(this.websocket.idPC) :
                        null;
                //Step 4.3 : Se non ho alcuna imformazione sul computer, ritorno il risultato
                if (currentPC == null)
                    return info.result;
                info.message.text = currentPC.notConnectedDefaultMessage;
                info.message.msgArgs = null;
            }



            // Caso 3.3 : Visualizzo il messaggio
            if (!info.message.command) {
                info.message.command = message;
            }

            this.emitFunction("sendClientMessage", info.message, info.message.command);


            //Step 4 : Restituisco il risultato
            return info.result;
        },


        checkSocket() {
            let self = this;
            //Caso 1 : Non è stata mai instanziata la connessione: creo la connessione
            if (self.websocket == null) {
                self.websocket = new WebSocketClient(this.authObj, this.emitFunction, this.translateFunction);
            }
            self.websocket.checkConnection();
        },


        async closeSocket() {
            if (this.websocket != null && this.websocket.websocket != null) {
                await this.websocket.websocket.close();
            }
            this.websocket = null;
        },

        async startToListenPC(idPC) {
            /*if (!this.socketConnected||this.websocket.idPC==idPC) {
                return;
            }*/
            var pc = await this.$api.getPC(idPC);
            if (pc == null) { return; }
            this.$session.setRoomPC(pc);
            this.socket("SETPC", idPC);



            let self = this;
            this.$off("socketEventConnected");
            this.$off("socketEventDisconnected");
            this.$root.$on("socketEventConnected", () => {
                self.socketConnected = true;
                self.checkConnectionTimerLight();

                // self.noIperiusOneLicensePolicies indica che c'è una licenza di monitoring, quindi la licenza di one. è true quando c'è la licenza di one.
                // il messaggio va mostrato solo se c'è una licenza di one
                if (this.connectionsStates[idPC] != undefined && !this.connectionsStates[idPC] && self.noIperiusOneLicensePolicies) {
                    this.toast(this.$t(pc.notConnectedDefaultMessage), "alert");
                    return;
                }
                self.socket("subscribe_pc", idPC)
                    .then((ok) => {
                        if (!ok) {
                            self.$root.$emit("roomPCConnectionStatus", false);
                            return;
                        }
                        self.roomPCInfo.subscribed = true;
                        self.socket("STARTSENDINFO").then(ok => {
                            if (!ok) {
                                self.$root.$emit("roomPCConnectionStatus", false);
                                return;
                            }
                            self.$root.$emit("roomPCConnectionStatus", true);
                            self.roomPCInfo.receivingRealtimeData = true;
                        });
                    });
                self.forceRefreshID += 1;
                //self.startToListenPC(self.idPC);
            });
            //"socketEventDisconnected" viene emesso se la connessione socket non è attiva
            this.$root.$on("socketEventDisconnected", () => {
                self.socketConnected = false;
                if (self.checkConnectionTimer != null) {
                    clearInterval(self.checkConnectionTimer);
                    self.checkConnectionTimer = null;

                }
                self.$root.$emit("roomPCConnectionStatus", false);
                //self.setDefaultData();
            });


            this.checkSocket();

        },

        async stopToListenPC(idPC) {
            //Questa chiamata non è più necessaria perché viene automaticamente effettuata dal server 
            //se dopo 60 secondi non c'è più nessuno in ascolto nella stanza del pc
            //console.log("stop = "+await this.$root.socket("STOPSENDINFO"));
            this.socket("SETPC", idPC);
            console.debug("unsubscribe = " + await this.socket("unsubscribe_pc", idPC));

            this.$session.setRoomPC(null);
            this.socket("SETPC", null);
            this.roomPCInfo.id = null;
            this.roomPCInfo.subscribed = false;
            this.roomPCInfo.receivingRealtimeData = false;
        },

        /********************************************************************************************************************************************/
        // Ricostruzione mappe usate dal modulo ticketing/billing.
        // Vanno richiamate dopo ogni create/edit/delete dell'entità relativa.
		async ensureUsefulMaps() {
			if (this.teamMap && this.customerMap && this.userMap && this.pcMap) return;
			if (this.usefulMapsPromise) return this.usefulMapsPromise;

			this.usefulMapsPromise = Promise.all([
				this.teamMap ? Promise.resolve() : this.rebuildTeamMap(),
				this.customerMap ? Promise.resolve() : this.rebuildCustomerMap(),
				this.userMap ? Promise.resolve() : this.rebuildUserMap(),
				this.pcMap ? Promise.resolve() : this.rebuildPcMap()
			]);
			try {
				await this.usefulMapsPromise;
			} finally {
				this.usefulMapsPromise = null;
			}
		},
        async rebuildTeamMap() {
            const teams = await this.$api.getTeams();
			if (Array.isArray(teams)) this.$session.setTeams(teams);
            this.teamMap = (this.$session.getTeams() || []).toMap("id");
        },
        async rebuildCustomerMap() {
            const customers = await this.$api.getCustomers();
            this.customerMap = (customers || []).toMap("id");
        },
        async rebuildUserMap() {
            const users = await this.$api.getUsers();
			if (Array.isArray(users)) this.$session.setUsers(users);
            this.userMap = (this.$session.getUsers() || []).map(u => ({
                id: u.id,
                username: u.username,
                firstname: u.firstname,
				lastname: u.lastname,
				role: u.role
            })).toMap("id");
        },
		async rebuildPcMap() {
			let pcs = this.$session.getPCList() || [];
			if (!this.$session.hasPCList()) {
				const response = await this.$api.getPCListUltraLite();
				pcs = Array.isArray(response) ? response : [];
				this.$session.setPCList(pcs);
			}
			const allPCs = pcs.map(pc => ({
                id: pc.id,
                pc_name: pc.pc_name || pc.name,
                id_remote: pc.id_remote
            }));
            this.pcMap = Object.assign(allPCs.toMap("id"), allPCs.toMap("id_remote"));
        },

        /********************************************************************************************************************************************/
        emitFunction(message, arg1, arg2) {
            if (message != "realtimeMessages" && message != "sendClientMessage") {
                this.$root.$emit(message, arg1, arg2);
                return;
            }

            var data = arg1;
            var command = arg2;

            //Data è il ClientMessage/ClientMessage da mostrare
            data = ClientMessage.fromAgent(data);


            if (message == "realtimeMessages" || data.isToast) {
                //Mostro tutti i messaggi in realtime e i client message che sono anche toast
                this.toast(this.$t(data.text, data.msgArgs), data.msgType);
            }

            if (message == "sendClientMessage" || message.startsWith("sendClientMessage_")) {
                if (data.command) {
                    command = data.command;
                }

                if (command && !data.command) {
                    data.command = command;
                }

                if (!data.command && !command) {
                    console.debug("!data.command && !command -> " + data.text)
                    //alert("!data.command && !command");
                    //alert(data.text);

                }
                this.$root.$emit("sendClientMessage_" + command.toUpperCase(), data);
            }

        },

        translateFunction(message, args = null) {
            if (args == null) {
                return this.$t(message);
            }

            if (Array.isArray(args)) {
                args = { ...args };
            }
            return this.$t(message, args);
        },

        generateUniqueId() {
            return Math.floor(100000 + Math.random() * 900000).toString();
        },

        sendNotification(title, options) {
            if (Notification.permission === 'granted') {
                new Notification(title, options);

                // Esempio di utilizzo
                /*  sendNotification('Benvenuto!', {
                     body: 'Grazie per aver visitato la nostra web app!',
                     icon: '/path/to/icon.png' // Icona per la notifica
                 }); */
            }
        },


        requestNotificationPermission() {
            console.log('Richiesta di permesso per le notifiche');

            if ('Notification' in window) {
                if (Notification.permission === 'granted') {
                    console.info('Notifiche abilitate!');
                } else {

                    Notification.requestPermission().then(permission => {
                        if (permission === 'granted') {
                            console.info('Notifiche abilitate!');

                            OneSignalSetup.subscribeUser(this.authObj.id_user, this.$i18n.locale);
                        } else {
                            console.writeError('Notifiche negate!');
                        }
                    });
                }
            } else {
                console.writeError('Le notifiche non sono supportate dal browser.');
            }
        },



        //MA: aggiornamento checkConnectionTimerAction con questo semplificato
        async checkConnectionTimerLight() {
            let self = this;

            //Se sono in una pagina diversa da quelle specificate, non ho bisogno del timer che controlla la connessione dei pc,
            //Quindi posso fermare il timer (se avviato)
            if (
                !["/dashboard", "/computers", "/backups", "/accounts", "/repo", "/activesessions", "/restores","/scripts/inventory", "/scripts/history"].some(urlPrefix => self.$route.path.startsWith(urlPrefix)) ||
                self.$route.path.startsWith("/backupstats")
            ) {

                if (self.checkConnectionTimer != null) {
                    clearInterval(self.checkConnectionTimer);
                }

                self.checkConnectionTimer = null;
                return false;
            }

            //Il timer attivo è di tipo number in javascript
            if (typeof (self.checkConnectionTimer) == 'number' || !isValid(self.$session.getPCList())) {
                return true;
            }

            var pcIDs = self.$session.getPCList().map(pc => pc.id);
            self.checkConnectionTimer = null;
            var roomPC;
            var newValues;

            self.checkConnectionTimer = setInterval(async () => {
                if (pcIDs.length == 0) {
                    pcIDs = self.$session.getPCList().map(pc => pc.id);
                    if (pcIDs.length == 0) {
                        self.connectionsStates = {};
                        self.atLeastOnePCConnectedToSocket = false;
                        return;
                    }
                }

                //Ritorna un oggetto in cui le chiavi sono gli id dei computer e i valori sono booleani che indicano se quel pc è connesso o no
                newValues = await self.$api.getPCsConnected(pcIDs);
                roomPC = self.$session.getRoomPC();

                if (roomPC == null) {
                    self.connectionsStates = newValues;

                    //Se non sono in un pc, controllo la risposta di "is_online", che sarà "true" se c'è almeno un valore idPC: true
                    this.atLeastOnePCConnectedToSocket = Object.values(self.connectionsStates).some(isConnectedValue => isConnectedValue);
                    return;
                }

                //Se sono in un pc, presto attenzione ai cambiamenti della connessione socket
                var isConnected_before = self.connectionsStates[roomPC.id];
                self.connectionsStates = newValues;
                var isConnected_after = self.connectionsStates[roomPC.id];
                this.atLeastOnePCConnectedToSocket = isConnected_after;

                //Quindi se la connessione non è cambiata esco
                if (isConnected_before == isConnected_after || isConnected_before == undefined) {
                    return;
                }

                //Altrimenti comunico alla pagina del pc che lo stato della connessione è cambiata
                //se il pc si è disconnesso, mostro un messaggio
                if (!isConnected_after) {
                    self.toast(self.$t(roomPC.notConnectedDefaultMessage), "alert");
                    self.$root.$emit("roomPCConnectionStatus", false);
                } else {
                    self.toast(self.$t(PC_MESSAGES.CONNECTED, { 0: roomPC.name }), "success");
                    // se il pc si è riconnesso, ripristino l'ascolto
                    this.startToListenPC(roomPC.id);
                    this.roomPCInfo.id = roomPC.id;
                }



            }, 5000);

            return true;

        },

        checkRemoteConnectionTimerLight() {
            //Caso 1 : Non bisogna monitorare alcuna connessione remote
            if (Object.keys(this.remote_map_idPC_idRemote).length == 0) {
                return;
            }

            //Il timer attivo è di tipo number in javascript
            if (this.remote_checkConnectionTimer != null && typeof (this.remote_checkConnectionTimer) == 'number') {
                return;
            }


            let self = this;

            // timer per controllo stato ogni 3 secondi
            self.remote_checkConnectionTimer = setInterval(() => {
                //Non bisogna monitorare alcuna connessione remote
                if (Object.keys(this.remote_map_idPC_idRemote).length == 0) {
                    clearInterval(self.remote_checkConnectionTimer);
                    self.remote_checkConnectionTimer = null;
                    return;
                }
                // api che verifica i remote connessi
                this.$api.getPCRemoteConnected(self.remote_map_idPC_idRemote).then((/*map_idRemote_connected, */map_idPC_connected) => {
                    //console.log("remote_checkConnectionTimer sta monitorando "+Object.keys(self.remote_map_idPC_idRemote).length+" computer");
                    self.remote_connectionsStates = map_idPC_connected;
                    //Object.assign(self.remote_connectionsStates, map_idPC_connected);
                });

            }, 5000);
        },


        blockSpaces(event) {
            // Prevenire l'inserimento dello spazio
            if (event.key === " ") {
                event.preventDefault();
            }
        },


        closeConnectionTimerLight() {
            this.$root.$off("is_online");
            clearInterval(this.checkConnectionTimer);
        },

        /***********************************************************TIPI*************************************************************/
        getAllBackupSourceTypes() {
            return Object.keys(this.$ONEServiceTypeInfo)
                .filter(t => this.$ONEServiceTypeInfo[t].forBackupSource && this.$ONEServiceTypeInfo[t].enabled)
                .map(t => parseInt(t));
        },
        getAllBackupDestinationTypes() {
            return Object.keys(this.$ONEServiceTypeInfo)
                .filter(t => this.$ONEServiceTypeInfo[t].forBackupDestination && this.$ONEServiceTypeInfo[t].enabled)
                .map(t => parseInt(t));
        },

        getMicrosoftTypes() {
            return Object.keys(this.$ONEServiceTypeInfo).filter(t => this.$ONEServiceTypeInfo[t].mainType == this.$ONEServiceType.Microsoft && this.$ONEServiceTypeInfo[t].enabled).map(t => parseInt(t));
        },
        getCloudTypes() {
            return Object.keys(this.$ONEServiceTypeInfo).filter(t => this.$ONEServiceTypeInfo[t].mainType == this.$ONEServiceType.Cloud && this.$ONEServiceTypeInfo[t].enabled).map(t => parseInt(t));
        },
        getEmailTypes() {
            return Object.keys(this.$ONEServiceTypeInfo).filter(t => this.$ONEServiceTypeInfo[t].mainType == this.$ONEServiceType.Email && this.$ONEServiceTypeInfo[t].enabled).map(t => parseInt(t));
        },

        getServiceAccountsTypes(all = false) {
            return Object.keys(this.$ONEServiceTypeInfo).filter(t => this.$ONEServiceTypeInfo[t].forServiceAccount && this.$ONEServiceTypeInfo[t].enabled && (all || this.$ONEServiceTypeInfo[t].mainType == -1)).map(t => parseInt(t));
        },
        getRepositoriesTypes() {
            return Object.keys(this.$ONEServiceTypeInfo).filter(t => this.$ONEServiceTypeInfo[t].forRepository && this.$ONEServiceTypeInfo[t].enabled && this.$ONEServiceTypeInfo[t].mainType == -1).map(t => parseInt(t));
        },
        getBackupSourcesTypes() {
            return Object.keys(this.$ONEServiceTypeInfo).filter(t => this.$ONEServiceTypeInfo[t].forBackupSource && this.$ONEServiceTypeInfo[t].enabled && this.$ONEServiceTypeInfo[t].mainType == -1).map(t => parseInt(t));
        },
        getRestoreFileDestinationTypes() {
            return [
                this.$ONEServiceType.FileFolder,
                this.$ONEServiceType.Network,
                this.$ONEServiceType.FTP,
                this.$ONEServiceType.Cloud_AmazonS3Storage,
                this.$ONEServiceType.Cloud_AzureBlob,
                this.$ONEServiceType.Cloud_AzureFile,
                this.$ONEServiceType.Cloud_Dropbox,
                this.$ONEServiceType.Cloud_GoogleDrive,
                this.$ONEServiceType.Cloud_IperiusS3Storage,
                this.$ONEServiceType.Cloud_OneDrive,
                this.$ONEServiceType.Cloud_S3CompatibleStorage,
                this.$ONEServiceType.Microsoft_OneDriveForBusiness,
                this.$ONEServiceType.Microsoft_SharePoint,
                this.$ONEServiceType.Microsoft_Teams
            ]
        },

        isValidEmail(email) {
            // Utilizzo di una regex per validare l'email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },


        /**
         * Veronica : Ho creato un oggetto per facilitare la lettura del codice e eventuali cambiamenti sulla logica
         * config = {
         *     path: // obbligatorio
         *     type: // obbligatorio
         *     prefix:
         *     repoName:
         *     saName
         * }
         */
        getPathAndName(config) {
            var path, name = "";
            if (config.prefix != undefined && config.path != config.prefix && !config.path.startsWith(config.prefix + config.type.getSeparator())) {
                config.path = config.prefix + config.type.getSeparator() + config.path
            }

            path = config.path;

            //Caso 1 : Se è stato passato il nome del repository, questo diventa il nome ritornato
            if (config.repoName != undefined) {
                return [path, config.repoName];
            }

            //Caso 2 : Se non è stato passato il nome del repository ma solo quello del service account,
            // lo concateno all'ultima parte del percorso (scrivo 'root' se il percorso passato è vuoto)
            if (config.saName != undefined && path == '') {
                name = config.saName + " - root";
                return [path, name];
            }

            if (config.saName != undefined && path != '') {
                name = config.saName + " - " + path.lastPartOfPath();
                return [path, name];
            }

            //Caso 3 : Se non è stato passato alcun nome e il tipo è filefolder
            // il nome ritornato sarà la concatenazione del nome del pc con l'ultima parte del percorso
            if (config.type == this.$ONEServiceType.FileFolder) {
                if (path == '') {
                    return [path, ""];
                }

                var roomPC = this.$session.getRoomPC();
                name = roomPC.name + " - " + path.trimEnd("\\").lastPartOfPath().trimEnd(":");
                return [path, name];
            }

            //Caso 4 (non dovrebbe mai andare qua) : ritorno un nome vuoto se non è filefolder 
            // e non è stato passato alcun repo o serviceaccount
            return [path, name];
        },


        copy(value) {
            navigator.clipboard.writeText(value).then(() => {
                this.toast(this.$t("Copied to clipboard"), "info");
            });
        },

        async refreshEcommerceUpgradeUrl() {
            const fallbackUrl = process.env.VUE_APP_ECOMM_SITE_URL;

            if (!fallbackUrl || !this.authObj || this.authObj.licenceExpired) {
                this.ecommerceUpgradeUrl = fallbackUrl;
                return fallbackUrl;
            }

            if (this.ecommerceUpgradeUrlPromise) {
                return this.ecommerceUpgradeUrlPromise;
            }

            this.ecommerceUpgradeUrlPromise = (async () => {
                try {
                    const url = await this.generateTrustedSsoUrl(fallbackUrl, 'ecomm', 'UPGRADE');
                    this.ecommerceUpgradeUrl = url || fallbackUrl;
                } catch (error) {
                    console.warn('E-commerce SSO URL non disponibile', error);
                    this.ecommerceUpgradeUrl = fallbackUrl;
                }

                return this.ecommerceUpgradeUrl;
            })();

            try {
                return await this.ecommerceUpgradeUrlPromise;
            } finally {
                this.ecommerceUpgradeUrlPromise = null;
            }
        },

        // [TG - 18/02/2025 - generazione link di “trusted sign-in” / single sign-on ]
        // [TG - 25/11/2025 - spostato qui in main.js perchè usato anche per accesso automatico su ecommerce da iperiusone]
        // [PV - 14/05/2026 - aggiunto parametro action che può essere "" (stringa vuota solo per la custom), "UPGRADE" o "RENEW"]
        async generateTrustedSsoUrl(baseurl, type, action) {

            let self = this;
            let urlcustom = '';

            // libreria crypto nativa di node.js
            const crypto = require('crypto');

            if (!self.checkAuth()) {
                return;
            }

            let ima = self.authObj.id_master_account;

            let cryLic = await self.$api.getCoCod(ima);

            if (cryLic != null) {

                const currentDate = new Date();
                const formattedDate = this.$moment(currentDate).format('YYYYMMDDhhmmss');

                const ragione_sociale = self.authObj.company;
                const ma_username = self.authObj.ma_username;
                const id_utente_ecomm = self.authObj.id_utente_ecomm;
                const vb_lang = localStorage.getItem('lang') ?? $i18n.locale ?? "en";

                if (type === 'ecomm') {
                    if (typeof baseurl !== 'string') {
                        console.error('generateTrustedSsoUrl: baseurl non è valido:', baseurl);
                        return;
                    }
                    baseurl = baseurl.replace('@TLD@', this.getTldByLang(vb_lang));
                }

                const control_code_sha256 = crypto.createHash('md5').update(id_utente_ecomm + '$$' + formattedDate).digest('hex');

                const ma_username_md5_sha256 = crypto.createHash('md5').update(ma_username).digest('hex');

                const query_string = id_utente_ecomm + '|' + ragione_sociale + '|' + action + '|' + formattedDate + '||' + vb_lang + '|' + control_code_sha256 + '|' + ma_username_md5_sha256;

                const param = await self.$api.getCrio(query_string);

                const trustedSrc = baseurl + '?lang=' + vb_lang + '&pl=' + encodeURIComponent(param.result);

                urlcustom = trustedSrc;

            }

            return urlcustom;

        },

        // [TG - 25/11/2025 - ritorna il dominio di 2° livello in base alla lingua corrente dell'interfaccia]
        getTldByLang(lang) {
            const code = (lang || '').toLowerCase();

            switch (code) {
                case 'es':
                    return '.es';
                case 'it':
                    return '.it';
                case 'de':
                    return '.de';
                case 'fr':
                    return '.fr';
                default:
                    return '.com';
            }
        },
        userDisplayName(idUser){
			if (!this.userMap) {
				this.ensureUsefulMaps().catch(error => console.writeError(error));
				return idUser || '';
			}
            const user = this.userMap && this.userMap[idUser];
			if (!user) {
				return idUser || '';
			}

			const fullName = [user.firstname, user.lastname].filter(Boolean).join(' ');
			if (fullName && user.username) {
				return `${fullName} (${user.username})`;
			}
			return fullName || user.username || idUser || '';
        }

    },
    components: {
        VueContext,
    },

    beforeDestroy: async function () {
        this.$off("socketEventConnected");
        this.$off("socketEventDisconnected");
        clearInterval(this.checkConnectionTimer);
        clearInterval(this.remote_checkConnectionTimer);

        this.checkConnectionTimer = null;
        window.removeEventListener("beforeunload", this._onBeforeUnload);
        window.removeEventListener("storage", this._onStorage);
        window.removeEventListener("keydown", this._onKeydown);
        document.removeEventListener("contextmenu", this._onContextMenu);

        this._onBeforeUnload = this._onStorage = this._onKeydown = this._onContextMenu = null;
        await this.closeSocket();
    },
    unmounted: async function () {
        this.$off("socketEventConnected");
        this.$off("socketEventDisconnected");
        clearInterval(this.checkConnectionTimer);
        clearInterval(this.remote_checkConnectionTimer);
        this.checkConnectionTimer = null;
        window.removeEventListener('keydown', this.handleShortcut);
        window.removeEventListener('storage');
        window.removeEventListener('beforeunload');
        window.removeEventListener('contextmenu');
        await this.closeSocket();
    },

    /* mounted: function() {
        Metro.init;
    }, */
    render: h => h(App),
}, { key: appKey });


app.$mount('#app');
